import React, { useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import ProfileTab from "../../components/admin/ProfileTab";
import { Box } from "@chakra-ui/react";

export default function Profile() {
  useEffect(() => {
    document.title = "Profile";
  }, []);

  return (
    <React.Fragment>
      <DashboardLayout>
        <Box mt='20px'>
          <ProfileTab />
        </Box>
      </DashboardLayout>
    </React.Fragment>
  )
}